import i18nConfig from "../assets/i18n"
let bootData = {
    sLanguageType: window.sLanguageType || 'zh-CN'
}
const registerI18n = function() {
    window.$st = function(data) {
        if(data) {
            let type = bootData.sLanguageType
            return i18nConfig[data] && i18nConfig[data][type] || data
        }
        return data
    }
}
Object.defineProperty(window,'sLanguageType',{
    set: function(val){
        bootData.sLanguageType = val
        registerI18n()
    },
    get() {
        return bootData.sLanguageType
    }
})

registerI18n()



// WEBPACK FOOTER //
// ./src/util/boot.js